import React, { useState, useEffect } from 'react';
import { Card, Flex, InputItem } from 'antd-mobile';

import { getSthousandsFormatNum } from "../utils/common";
import * as Api from "../../../api/usms";
import { getSmsType } from '../../localStorage';
import { renderDate, timeFormatType } from '../utils/timeFormat';
import { UrlSearch } from "../../../utils/utils";
import { ConsolePurpose, PackageSmsStatus, DomesticFlag } from "../utils/const";

// import 'moment/locale/zh-cn';

import { Empty, Loading } from '../components';


export default function StatisticPackage(props) {

  const smsType = getSmsType();

  // 是否客户经理专用链接
  const ifManager = window.location.pathname.indexOf("/usms/manager/") > -1;

  const [companyId, setCompanyId] = useState();
  const [companyName, setCompanyName] = useState();

  const [searchPackage, setSearchPackage] = useState();

  // 统计
  const [list, setList] = useState([]);
  const [originList, setOriginList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    initData();
  }, [])

  const initData = () => {
    const company_id = Number(UrlSearch("company_id"));
    const company_name = UrlSearch("company_name");

    setCompanyId(company_id);
    setCompanyName(company_name);

    if (!company_id) {
      setErrorMessage("缺失参数");
      return
    }
    const data = {
      CompanyId: company_id,
      Limit: 9999,
      Offset: 0
    }
    // setLoading(true);
    setList([]);
    setOriginList([]);
    setErrorMessage("");

    // 查询套餐包列表
    Api.GetCompanyBuyRecord(data).then(res => {
        setList(res);
        setOriginList(res);
        setLoading(false);
    }).catch(e => {
        setLoading(false);
        setErrorMessage(e.message || "获取数据失败")
    });
  }

  const renderList = () => {
    if (list.length === 0) {
      return <Empty />
    }

    return list.map((item, index) =>
      <Card full style={{ marginBottom: '8px' }}
        key={index}
      >
        <Card.Header title={`${index + 1}. ${item.PackageName}`} />
        <Card.Body>
          <div
            style={{ borderBottom: '1px solid #E9E9E9' }}
          >
            <Flex>
              <Flex.Item style={{ fontSize: '12px', padding: '1px' }}>
                <span>套餐包ID：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{item.PackageId}</span>
              </Flex.Item>
            </Flex>
            <Flex>
              <Flex.Item style={{ fontSize: '12px', padding: '1px' }}>
                <span>状态：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{PackageSmsStatus[item.Status]}</span>
              </Flex.Item>
              <Flex.Item style={{ fontSize: '12px', padding: '1px' }}>
                <span>短信类型：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{ConsolePurpose[item.Purpose]}</span>
              </Flex.Item>
            </Flex>
            <Flex>
              <Flex.Item style={{ fontSize: '12px', padding: '1px' }}>
                <span>国家：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{DomesticFlag[item.DomesticFlag]}</span>
              </Flex.Item>
            </Flex>
            <Flex>
              <Flex.Item style={{ fontSize: '12px', padding: '1px' }}>
                <span>短信总量：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{getSthousandsFormatNum(item.BuyQuantity)}</span>
              </Flex.Item>
              <Flex.Item style={{ fontSize: '12px', padding: '1px' }}>
                <span>短信剩余量：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{getSthousandsFormatNum(+item.BuyQuantity - +item.UsedQuantity)}</span>
              </Flex.Item>
            </Flex>
            {!ifManager ? <Flex>
              <Flex.Item style={{ fontSize: '12px', padding: '1px' }}>
                <span>价格（元）：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{getSthousandsFormatNum(item.CostAmount / 100)}</span>
              </Flex.Item>
              <Flex.Item style={{ fontSize: '12px', padding: '1px' }}>
                <span>单价（元）：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{item.CostAmount > 0 ? (item.CostAmount / 100 / item.BuyQuantity).toFixed(5) : item.CostAmount}</span>
              </Flex.Item>
            </Flex>: null}
            <Flex>
              <Flex.Item style={{ fontSize: '12px', padding: '1px' }}>
                <span>到期时间：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{renderDate(item.ValidTime * 1000, timeFormatType.time_xg)}</span>
              </Flex.Item>
            </Flex>
          </div>
        </Card.Body>
      </Card>
    )
  }

  const onPackageChange = value => {
    setSearchPackage(value);
    if (value === "") {
      setList(originList);
    } else {
      const filterList = originList.filter(item => (item.PackageId + '').indexOf(value) > -1);
      setList(filterList);
    }
  }

  return (
    <div className="container">
      <h3 style={{ marginBottom: '10px' }}>{`${smsType === 'Text' ? 'USMS' : 'ISMS'} 预付费套餐包:`}</h3>
      <Loading loading={loading} error={errorMessage}>
        <h3 style={{ marginBottom: '10px' }}>{`${(companyName) || ""}(${companyId})`}</h3>
        <div style={{ marginBottom: '10px' }}>
          <InputItem
            size="small"
            placeholder="搜索套餐包ID"
            value={searchPackage}
            onChange={onPackageChange} >搜索</InputItem>
        </div>
        {renderList()}
      </Loading>
    </div>
  )
}